var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThrashBinGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0847 9H6.91797",
    stroke: "#888DA5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6936 11.082L19.3103 16.8313C19.1628 19.0437 19.0891 20.1499 18.3682 20.8243C17.6474 21.4987 16.5387 21.4987 14.3214 21.4987H13.6769C11.4596 21.4987 10.3509 21.4987 9.63005 20.8243C8.90921 20.1499 8.83547 19.0437 8.68797 16.8313L8.30469 11.082",
    stroke: "#888DA5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41797 9C9.46454 9 9.48782 9 9.50893 8.99947C10.1951 8.98208 10.8005 8.54576 11.034 7.90027C11.0412 7.88041 11.0485 7.85832 11.0633 7.81415L11.1442 7.57143C11.2132 7.36423 11.2478 7.26063 11.2936 7.17267C11.4763 6.82173 11.8144 6.57803 12.2051 6.51564C12.3031 6.5 12.4123 6.5 12.6307 6.5H15.3719C15.5903 6.5 15.6995 6.5 15.7975 6.51564C16.1882 6.57803 16.5263 6.82173 16.709 7.17267C16.7548 7.26063 16.7894 7.36423 16.8584 7.57143L16.9394 7.81415C16.9541 7.85826 16.9614 7.88042 16.9686 7.90027C17.2021 8.54576 17.8075 8.98208 18.4937 8.99947C18.5148 9 18.5381 9 18.5846 9",
    stroke: "#888DA5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrashBinGrey);
export default __webpack_public_path__ + "static/media/Thrash-bin-grey.e58afa6e75df45b58761092142fc2c6c.svg";
export { ForwardRef as ReactComponent };